export const formDataSaqB = [
  // Page 9 - Done
  {
    _uid: "e9f0354a-d2d4-457f-a3c0-212b1ede86c0",
    layout: "form",
    component: "page",
    title: "Assessment Information",
    label: "",
    simplifiedLabel: "Instructions for Submission",
    caption: "",
    simplifiedCaption: "",
    simplifiedNotes:
      "This document must be completed as a declaration of the results of the merchant’s self-assessment against the Payment Card Industry Data Security Standard (PCI DSS) Requirements and Testing Procedures. Complete all sections. The merchant is responsible for ensuring that each section is completed by the relevant parties, as applicable. Contact the entity(ies) to which the Attestation of Compliance (AOC) will be submitted for reporting and submission procedures.",
    fields: [
      {
        _uid: "b73f650e-e0d7-4f8d-9040-37f60a9c2da8",
        component: "label",
        type: "",

        boldLabel: [
          "Part 1. Contact Information",
          "Part 1a. Assessed Merchant",
        ],
        simplifiedLabel: "",
      },
      {
        _uid: "d8286d28-f60b-43c2-b392-f969ad4993bb",
        component: "text",
        type: "text",

        label: "Company Name",
        simplifiedLabel: "Company Name",
        maxLength: "120",
      },
      {
        _uid: "5174ec78-8bc2-43d7-ba07-cff93ab2e737",
        component: "text",
        type: "text",
        label: "DBA (doing business as):",
        simplifiedLabel: "DBA (doing business as):",
        maxLength: "120",
      },
      {
        _uid: "4595839c-90fc-4692-84dc-a4597e635b13",
        component: "text",
        type: "text",
        label: "Company mailing address:",
        simplifiedLabel: "Company mailing address:",
        maxLength: "120",
      },
      {
        _uid: "7e6768ef-c046-4d39-82d0-6bdc6af3f79d",
        component: "text",
        type: "text",
        label: "Company main website:",
        simplifiedLabel: "Company main website:",
        maxLength: "120",
      },
      {
        _uid: "0ab0a774-b4c2-43fe-bcfc-77155900ae1c",
        component: "text",
        type: "text",
        label: "Company contact name:",
        simplifiedLabel: "Company contact name:",
        maxLength: "58",
      },
      {
        _uid: "a67c6ac6-d624-4843-bbfb-947dff788695",
        component: "text",
        type: "text",
        label: "Company contact title:",
        simplifiedLabel: "Company contact title:",
        maxLength: "120",
      },
      {
        _uid: "68ef902a-7f26-43c4-b493-ceab3c6d69e2",
        component: "text",
        type: "text",
        label: "Contact phone number:",
        simplifiedLabel: "Contact phone number:",
        maxLength: "120",
      },
      {
        _uid: "248627b6-0c99-402d-9ab8-1118f4fbca46",
        component: "text",
        type: "text",
        label: "Contact e-mail address:",
        simplifiedLabel: "Contact e-mail address:",
        maxLength: "120",
      },
      {
        _uid: "90846333-85b3-4ae3-b5d2-6eee695fabb5",
        component: "label",
        type: "",
        boldLabel: "Part 1b. Assessor",
        notes: [
          "Provide the following information for all assessors involved in the assessment. If there was no assessor for a given assessor type, followings are Not Applicable.",
          "PCI SSC Internal Security Assessor(s)",
        ],
        boldNotes: "",
      },
      {
        _uid: "76603005-75e8-4992-b248-da95ddcdbe4b",
        component: "text",
        type: "text",
        label: "ISA name(s):",
        simplifiedLabel: "",
        maxLength: "13",
        col: "12",
      },
      {
        _uid: "c8d8d852-50fd-4440-8082-814073afe5eb",
        component: "label",
        type: "",
        label: "Qualified Security Assessor",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bfa8f531-460c-4b37-8743-fd09797942b4",
        component: "text",
        type: "text",
        label: "Company name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "39ba999d-b41a-4fcb-8312-aa1a05c16d87",
        component: "text",
        type: "text",
        label: "Company mailing address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "e3b3b310-9079-4df9-8767-d152a7e1b6f7",
        component: "text",
        type: "text",
        label: "Company website:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "862d75b4-2710-42cc-be34-26c82a56d8a6",
        component: "text",
        type: "text",
        label: "Lead Assessor Name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bea46930-82b4-40ac-9d2b-a40254c9c4f4",
        component: "text",
        type: "text",
        label: "Assessor phone number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "91e3cf83-2ff3-438f-b828-b4ff656533b3",
        component: "text",
        type: "text",
        label: "Assessor e-mail address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "4bdda341-517c-44a9-ac6e-cecbd8800af6",
        component: "text",
        type: "text",
        label: "Assessor certificate number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
    ],
  },
  // Page 10 - Done
  {
    _uid: "a465fe58-b84c-453d-b45a-fe96e6b60f4d",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "2a1a0ed9-9510-468c-b574-f1d5d6bb6904",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        simplifiedBoldCaption: [
          "Part 2. Executive Summary",
          "Part 2a. Merchant Business Payment Channels (select all that apply):",
        ],
        caption:
          "Indicate all payment channels used by the business that are included in this assessment.",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e0119add-86a8-4c41-9c89-edcdef842b86",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Mail order/telephone order (MOTO)",
                value: "Mail order/telephone order (MOTO)",
                col: 4,
              },
              {
                _uid: "3337cc28-09e7-43c5-b42f-1bcf81b2b336",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "E-Commerce",
                value: "E-Commerce",
                col: 4,
              },
              {
                _uid: "e8608b32-69d1-4030-a480-5ed6db79117d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Card-present",
                value: "Card-present",
                col: 4,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "756ddf69-eb1c-4961-a641-89f2b2cf22d5",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Are any payment channels not included in this assessment?",
                  "If yes, indicate which channel(s) is not included in the assessment and provide a brief explanation about why the channel was excluded.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
                colSpan: "2",
              },
              {
                _uid: "becc5fbd-536b-4344-a8f2-569560cdcf83",
                component: "col",
                label:
                  "Are any payment channels not included in this assessment? If yes, indicate which channel(s) is not included in the assessment and provide a brief explanation about why the channel was excluded. ",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [
                    "d18c2852-aa25-417d-875e-4e4df19e01c3",
                    "f6a6fedd-d5ed-4ad3-9bca-f4db89ace559",
                    "36804892-0122-42c9-a8dc-cfe8252a1fa6",
                    "d7f6d72c-e605-444e-be81-0ca0271b6748",
                    "2f961a8b-4b0c-4566-8952-5f6b7c7fbf9d",
                    "cc5d42b9-2842-4d02-be70-b6083baf0bd8",
                  ],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f892cf83-57a2-4ca2-9462-677052bd693a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Note: If the organization has a payment channel that is not covered by this SAQ, consult with the entity(ies) to which this AOC will be submitted about validation for the other channels.",
                  ,
                ],
                boldLabel: "",
                subLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 3,
                width: "100%",
              },
            ],
          },
        ],
      },
      {
        _uid: "efdd7555-1f29-458b-a1dd-816e87283495",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        boldCaption: "Part 2b. Description of Role with Payment Cards",
        simplifiedNotes:
          "For each payment channel included in this assessment as selected in Part 2a above, describe how the business stores, processes, and/or transmits account data.",
        headers: [
          "Channel",
          "How Business Stores, Processes, and/or Transmits Account Data",
        ],
        conditional: {
          value: "yes",
          field:
            "9cd9ade3-19c3-4d87-b053-b9e0b6a48321_becc5fbd-536b-4344-a8f2-569560cdcf83",
        },
        fields: [
          {
            fields: [
              {
                _uid: "d18c2852-aa25-417d-875e-4e4df19e01c3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "f6a6fedd-d5ed-4ad3-9bca-f4db89ace559",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "36804892-0122-42c9-a8dc-cfe8252a1fa6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "d7f6d72c-e605-444e-be81-0ca0271b6748",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2f961a8b-4b0c-4566-8952-5f6b7c7fbf9d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "cc5d42b9-2842-4d02-be70-b6083baf0bd8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
        ],
      },
      {
        _uid: "31a9db8f-58ef-4652-98ce-b95eac326dff",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: ["Part 2c. Description of Payment Card Environment"],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "2bde7286-8572-48ce-9ad4-e87e48e35b54",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Provide a high-level description of the environment covered by this assessment.",
                  "For example:",
                  "Connections into and out of the cardholder data environment (CDE).",
                  "Critical system components within the CDE, such as POI devices, databases, web servers, etc., and any other necessary payment components, as applicable.",
                  "System components that could impact the security of account data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "65c8932a-c344-4919-bd76-f9040a57ec25",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 500,
                col: "12",
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2c352136-6c7c-47b7-a88b-13c9381f4982",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Indicate whether the environment includes segmentation to reduce the scope of the assessment.",
                  "(Refer to “Segmentation” section of PCI DSS for guidance on segmentation.)",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
              },

              {
                _uid: "d64b5973-1566-43e1-9b8f-874b1fde5985",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 11 - Done
  {
    _uid: "d5869fe8-b683-4af8-8f4d-9e078a6397d7",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "",
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "c928b6b0-95c5-4f74-97f9-aa4337210a12",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [
          "List all types of physical locations/facilities (for example, retail locations, corporate offices, data centers, call centers, and mail rooms) in scope for the PCI DSS assessment.",
        ],
        simplifiedBoldCaption: [
          "Part 2. Executive Summary (continued)",
          "Part 2d. In-Scope Locations/Facilities",
        ],
        headers: [
          "Facility Type",
          [
            "Total number of locations",
            "(How many locations of this type are in scope)",
          ],
          "Location(s) of facility (city, country)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f538e4fb-d0ac-4a62-a9f2-528eda4a4e10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "acf5d0af-3f42-442f-800e-4d6c222b6351",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "9d917ce7-1041-4f79-870f-1b4c39ee603c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4e21fb8b-f941-41a2-baba-728508c9d5e7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "cc43fff6-bf6d-4fd2-8f27-dd05739eb088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "8976e226-42f4-4623-873e-253d2e9b813a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7dafe126-42b5-43ad-af9d-f9b1c04292d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "43",
              },
              {
                _uid: "99d91a88-dc68-4ccd-86b5-f9062f0634cd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "87469c76-72f0-4c65-a4aa-3ad546651328",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3fd13af2-ff06-4a89-8065-49d9312289b9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "38480e9b-5ba4-4c37-be48-32033a5f1cce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "afe658c1-09ca-43bc-a1c6-d9c27d50930a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a41379e-f356-4293-a495-5feee49f0b73",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "003752c8-ce7b-4082-963b-e822647a915f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "6bbac7ef-44fe-418f-aa3d-033ff84d30f2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e172cf04-218b-4289-b04f-0da438a8df10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "51a688d4-e852-409b-b521-49ca21d681e6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "14f3a088-0a71-4190-af9c-dddfc05edcd7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "216d893f-c246-4c7a-a4ba-6bc4bd82a3d2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "a1709a35-c76f-40e5-9163-b022945aef2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "a38dbab5-d50b-48e7-a952-1aa490b4186e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be1c6190-cf0d-4811-a1d5-2a0ccac73702",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "57fb74a7-b50f-4792-9291-32d1fb8a80be",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "66f7fe42-0057-4e43-84cc-cf28e2577ab1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
        ],
      },
      {
        _uid: "a89467ec-e1b2-4db7-9910-d0bb46c97936",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedBoldCaption: [
          "Part 2e. PCI SSC Validated Products and Solutions",
        ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "8dc8633d-b76c-46cb-9d7f-945fba5fe4ab",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Does the merchant use any item identified on any PCI SSC Lists of Validated Products and Solutions*?",
                boldLabel: "",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "cd991465-68c7-49d9-82ba-2769db9bb9f8",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "20%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [
                    "857d8004-08b2-4aea-b555-d72df62dce09",
                    "af826cd7-9a19-4125-a398-1daca49c93b0",
                    "2825014b-e992-463f-bc4a-9cf9195e509a",
                    "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                    "6ae39d41-7512-4548-8961-587d4df0197a",
                    "4ea9b5d7-3616-46bf-ac0a-53ae99959724",
                    "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                    "f971e7b0-2b1f-40af-a24f-83429fc13077",
                    "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                    "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                    "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                    "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                    "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                    "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                    "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                    "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                    "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                    "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                    "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                    "da5394e3-10e8-4508-baa3-81999f827530",
                    "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                    "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                    "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                    "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                    "10858523-2cc8-42fe-8c64-b81d620b5602",
                    "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                    "70398dd7-a086-45ac-b91e-72912d800505",
                    "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                    "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                    "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                    "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                    "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                    "72e92d2c-0158-4ab3-8194-2ab827652d49",
                    "73dc086f-719a-43ad-a5a4-77ae1e702737",
                    "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                    "1e5f30f3-db60-41fc-be94-99394652aab5",
                    "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                    "470582c3-2690-4bdc-9482-c21593e80306",
                    "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                    "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                    "8413cd02-9a1e-4e99-a021-da94cb98964d",
                    "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                    "d82e5669-4111-45c0-ac13-2fba7e575e91",
                    "3e0115af-7b42-481f-acee-badb6ed4cee9",
                    "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                    "da9bd7e1-7756-4680-9791-7f6e96431209",
                    "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                    "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                    "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                    "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "025ab84f-6a71-4eb7-8f04-2689074c13ab",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [
          "Provide the following information regarding each item the merchant uses from PCI SSC’s Lists of Validated Products and Solutions.",
        ],
        headers: [
          "Name of PCI SSCvalidated Product or Solution",
          "Version of Product or Solution",
          "PCI SSC Standard to which product or solution was validated",
          "PCI SSC listing reference number",
          ["Expiry date of listing", "(YYYY-MM-DD)"],
        ],
        conditional: {
          value: "yes",
          field:
            "51ca7282-7b1f-4a2f-b782-79be8343e7c1_cd991465-68c7-49d9-82ba-2769db9bb9f8",
        },
        fields: [
          {
            fields: [
              {
                _uid: "857d8004-08b2-4aea-b555-d72df62dce09",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "af826cd7-9a19-4125-a398-1daca49c93b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "2825014b-e992-463f-bc4a-9cf9195e509a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "6ae39d41-7512-4548-8961-587d4df0197a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "f971e7b0-2b1f-40af-a24f-83429fc13077",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "9e74c805-23ee-4d16-a51f-f6c74cced99d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da5394e3-10e8-4508-baa3-81999f827530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10858523-2cc8-42fe-8c64-b81d620b5602",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "70398dd7-a086-45ac-b91e-72912d800505",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "73dc086f-719a-43ad-a5a4-77ae1e702737",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "72e92d2c-0158-4ab3-8194-2ab827652d49",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "470582c3-2690-4bdc-9482-c21593e80306",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "1e5f30f3-db60-41fc-be94-99394652aab5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "3e0115af-7b42-481f-acee-badb6ed4cee9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "d82e5669-4111-45c0-ac13-2fba7e575e91",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "8413cd02-9a1e-4e99-a021-da94cb98964d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da9bd7e1-7756-4680-9791-7f6e96431209",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2db59afe-278f-4b86-bbc4-ac81bfc7e65f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "aba94212-b44a-4db1-a4f7-6fedcee8a088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "66b7e2f1-acdb-4e88-bba1-16952457391b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "50e7d770-6fdb-4263-bfd3-80221c923409",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "5fde4761-84ea-4bfa-9373-deec9de1e5d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 12 - Done
  {
    _uid: "4458e8f7-e370-4374-9236-fedb568d386c",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: [""],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "12dd2ae9-c92c-4cbb-a27b-508800ccd13d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedBoldCaption: [
          "Part 2. Executive Summary (continued)",
          "Part 2f. Third-Party Service Providers",
        ],
        simplifiedNotes:
          "Does the merchant have relationships with one or more third-party service providers that:",
        description: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "77a713ed-4ff6-452a-b734-da1efd99d5ca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Store, process, or transmit account data on the merchant’s behalf (for example, payment gateways, payment processors, payment service providers (PSPs), and off-site storage)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "f6008d00-b75a-4365-ba05-d8bf3ecbc1ef",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6db36531-1ce3-4165-b52d-9a2374fb8c42",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Manage system components included in the scope of the merchant’s PCI DSS assessment⎯for example, via network security control services, anti-malware services, security incident and event management (SIEM), contact and call centers, web-hosting services, and IaaS, PaaS, SaaS, and FaaS cloud providers.",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "81f787dd-10d8-46b1-a23a-ee14b6023f9d",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23c7a84b-4643-4273-b554-3f91d30b3e77",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Could impact the security of the merchant’s CDE (for example, vendors providing support via remote access, and/or bespoke software developers)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "8f9739c3-7fc5-4f0c-b332-f162c9d7aed1",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "2f338460-a095-4ffb-b4a8-22a3d9fb5893",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedBoldCaption: "If Yes:",
        description: "",
        headers: [
          "Name of service provider:",
          "Description of service(s) provided:",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f35caf1e-3a60-4746-9ef5-d007213511dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "32",
              },
              {
                _uid: "28bfc7d7-e540-4e88-95a2-547518438ba6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84b9c58d-9986-4eb0-bc08-7f8cf0c0e524",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "fbd53ce8-3f9e-46b0-aabe-79323c139bfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fd603daf-0b36-4383-aeeb-f58e5692e985",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "399fb414-c456-4931-8808-33c05cfab7bc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eb0bc36b-82dc-40fa-b7aa-7ff5e0af4cfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "0101ea03-da19-4f76-a45b-857dfb4ee9f4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1970ac65-2a00-4f3c-b8d2-5c21077d1719",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "42aeb606-9f62-40f7-99b3-a1f6b12a4b5a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d23c6de6-160a-40e4-b881-e498e2d51259",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "64a6951d-2d21-42ab-9f79-cd0f3366382e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fe9f7390-8933-4d12-8a05-df59c6cdf31e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "ef7743a3-aa47-45c9-949d-685025e9f75c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8c646ef1-b638-4136-970d-7871d2eeffa0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "135d1557-8797-43f0-a0c8-efc873846530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "878df552-46e2-4fdd-ae6e-b21c32d017ab",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "9bdaab35-c22e-430a-a756-84d69d7f084a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b84a619d-150f-45a6-be23-0080e3572762",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "30",
              },
              {
                _uid: "9f4dfcce-65a5-4cc6-9508-225e668ea9da",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "07b21b02-0f67-4a37-acba-d860060e9b21",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Note: Requirement 12.8 applies to all entities in this list.",
                placeholder: "",
                type: "",
                textareaRows: "2",
                col: "12",
                width: "100%",
                maxLength: "",
                colSpan: "2",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 13 - Done
  {
    _uid: "1979dffb-311b-4c6b-a5bd-728b94f3a09a",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "",
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "28b86930-17c4-4d25-ab53-d3fccacec03d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        simplifiedBoldCaption: [
          "Part 2. Executive Summary (continued)",
          "Part 2g. Summary of Assessment",
        ],
        simplifiedNotes: [
          "(SAQ Section 2 and related appendices)",
          "Indicate below all responses that were selected for each PCI DSS requirement.",
        ],
        headers: [
          {
            colSpan: "1",
            width: "30%",
            value: "PCI DSS Requirement *",
          },
          {
            colSpan: "4",
            width: "70%",
            value: [
              "Requirement Responses",
              "More than one response may be selected for a given requirement. Indicate all responses that apply.",
            ],
          },
        ],
        fields: [
          {
            fields: [
              {
                _uid: "4a042793-9fa8-40e4-a886-910b49be7f64",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "894c0e11-bdec-4d35-9c08-053a4e0892c5",
                component: "col",
                label: "",
                simplifiedLabel: "In Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2a5ef996-9789-4d82-9a7a-85b6ceea4edf",
                component: "col",
                label: "",
                simplifiedLabel: "In Place with CCW",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dd4bf0c5-bcc7-4fa5-8ffa-916c69770fd5",
                component: "col",
                label: "",
                simplifiedLabel: "Not Applicable",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "35d88a10-345f-4474-9c5a-d36b8f4164a0",
                component: "col",
                label: "",
                simplifiedLabel: "Not in Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be7e92ae-e202-4df9-8340-8c8e38738fdd",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 3:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "83483870-440a-4692-87c0-bd4b452cc5e6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3f957dfe-807a-44ea-9d07-5341d0c04327",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "99b311d0-504d-4835-a4e6-d918a461561c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3320a5b6-414d-4d2d-8cf2-38a54f01a264",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a89de058-db5e-4a7d-907f-340c6cc5b873",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 7:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d74498b3-96f3-4ea3-9bd2-8a054d8fc876",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2b03a47c-d91f-4853-92f9-5e7e80fcc6d0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e94cee9b-0a6f-4677-ae95-4f69775b638d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f763fa5e-8e3e-4058-9a34-088057f216dd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b4d424b9-913d-4c37-a468-8b7f57d705d1",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 9:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a19bb29e-d722-4863-90d0-3c486cb85118",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "68e7f630-a0b1-491c-89a2-f6115f3e3316",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "859de499-676f-4ddd-84ff-bbd282d3d616",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "07299892-5bf3-480d-888f-8cdb4f097f7e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8e249f70-e94c-4fea-a0d8-2ef0f4e3a168",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 12:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6785db61-e5fa-4ee6-a999-0b77dd7c2492",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7b7a9017-5ad1-4e63-b999-9f32b48a8e54",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "cee30fd0-06b2-4e5e-9df5-27eb3ded7f74",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c47fbe40-d723-41ff-a616-2dd335369c08",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          /* {
            fields: [
              {
                _uid: "afc55d56-558c-4972-999c-647b52b319c0",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 9:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "112fdc6c-d2ba-4884-be04-8ffd5eccafb5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c0700179-ddd9-413c-a9f0-9bdc04b00108",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3d1bdb4f-532a-4b89-94ed-1af2c997b866",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bffb79f6-dbb8-4f1b-8ac5-0f2bb32d5210",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1c4e1fa-d2ef-4eec-aa61-93d01419b8b5",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 11:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d985904e-543b-46c5-abf3-496c389a0c67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6ea5fa98-f6cd-4e59-9758-91fc6d703c82",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "526b27a9-f398-4940-96e2-37afe1393309",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "eeee435a-0da8-4611-af63-6cc6367af20b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "56c7306a-4cbb-46ab-8f21-c84926a5ffff",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 12:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fca7f4a9-f065-4f18-a367-130e62dc1e04",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fb698b06-b4a8-4614-bc58-8357e5c2dad6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e863bdc1-4d51-449e-ba9b-f8cfa68f7b07",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "20e88de4-ff63-491d-9422-d1db9a480d77",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          }, */
        ],
      },
      {
        _uid: "8ed72c89-084c-4630-a396-4c37d34e7550",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        fields: [
          {
            fields: [
              {
                _uid: "48174c70-534d-4286-97a4-09fe65326e98",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2h. Eligibility to Complete SAQ B",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a6b34cdb-23f7-4200-9c33-82e74843690b",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Merchant certifies eligibility to complete this Self-Assessment Questionnaire because, for this payment channel:",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "24dd15f3-a29c-4234-bcff-6ff3a1dbff59",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "a6b34cdb-23f7-4200-9c33-82e74843690b",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The merchant uses only an imprint machine and/or uses only standalone, dial-out terminals (connected via a phone line the merchant processor) to take customers’ payment card information",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "81f1895d-249d-41d6-9deb-0453906ec813",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "51da8a41-09b8-402d-8148-d3eb658fbc04",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The standalone, dial-out terminals are not connected to any other systems within the merchant environment.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2b4bd876-c731-480b-ba55-15162a61a806",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "da898916-e1a0-448d-951f-8d8723aaaadf",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The standalone, dial-out terminals are not connected to the Internet.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f47414b-7eb2-4988-9d26-f34ae2234afe",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "90bd450d-aec4-4b7b-bd26-5e80662c72b3",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The merchant does not store account data in electronic format.",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c71a61a-9ebd-42aa-8bb8-f8506ce6d085",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "9c73bce1-511b-4055-814f-a5602ef37148",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Any account data the merchant might retain is on paper (for example, printed reports or receipts), and these documents are not received electronically.",
                width: "90%",
                col: "12",
              },
            ],
          },
          /*
          {
            fields: [
              {
                _uid: "41322a08-54f4-4445-899d-bfd8e87c239a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "b6bd2d07-3d30-4747-b0fb-43c939b11064",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Additionally, for e-commerce channels: ",
                  "All elements of the payment page(s)/form(s) delivered to the customer’s browser originate only and directly from a PCI DSS compliant TPSP/payment processor.",
                ],
                width: "90%",
                col: "12",
                hasLi: "no",
              },
            ],
          }, */
        ],
      },
    ],
  },
  // Above are not done yet
  // Page 14 - 26 - Done
  {
    _uid: "b484238a-219c-41e6-a582-89c526af6f68",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "Section 2: Self-Assessment Questionnaire B",
    caption: "",
    simplifiedCaption: "",
    notes: "",
    simplifiedNotes:
      "Note: The following requirements mirror the requirements in the PCI DSS Requirements and Testing Procedures document",
    fields: [
      {
        _uid: "84f9cf72-4804-4319-8bd2-539bb3199936",
        component: "table",
        type: "table",
        simplifiedCaption: "",
        boldCaption: [],
        simplifiedBoldCaption: [
          "Protect Account Data",
          "Requirement 3: Protect Stored Account Data",
        ],
        notes: "",
        simplifiedNotes:
          "Note: For SAQ B, Requirement 3 applies only to merchants with paper records that include account data (for example, receipts or printed reports).",
        headers: [
          {
            colSpan: "2",
            width: "25%",
            value: "PCI DSS Requirement",
          },
          {
            colSpan: "1",
            width: "15%",
            value: "Expected Testing",
          },
          {
            colSpan: "2",
            value: "Response (Check one response for each question)",
          },
        ],
        fields: [
          // prefill options
          {
            fields: [
              {
                _uid: "3b5ca71f-e339-4c63-9426-3973a292a5d3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "65%",
                colSpan: 3,
              },
              {
                _uid: "c05aa970-2112-450b-bdad-d542eaa88dd6",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "select",
                options: [
                  {
                    value: "in_place",
                    label: "In Place",
                  },
                  {
                    value: "in_palce_with_CCW",
                    label: "In Place with CCW",
                  },
                  {
                    value: "na",
                    label: "Not Applicable",
                  },
                  {
                    value: "not_in_place",
                    label: "Not in Place",
                  },
                ],
                col: "12",
                width: "35%",
                colSpan: 2,
              },
            ],
          },
          // page 14 - Done
          {
            fields: [
              {
                _uid: "13a7b01d-93d4-4e63-a658-75711d55cb20",
                component: "col",
                label: "",
                boldLabel: [
                  "3.1 Processes and mechanisms for protecting stored account data are defined and understood.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "aa8978a1-43d0-4ae6-b1e0-bf3958f39568",
                component: "col",
                label: "",
                simplifiedLabel: "3.1.1",
                hasLi: "no",
                type: "",
                col: "",
                width: "5%",
              },
              {
                _uid: "38aaf92a-fbc8-492c-a298-6ca4499deebf",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "All security policies and operational procedures that are identified in Requirement 3 are:",
                  ul: [
                    "Documented",
                    "Kept up to date.",
                    "In use.",
                    "Known to all affected parties.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "",
                width: "20%",
              },
              {
                _uid: "506bae8e-f2c2-42ae-b9a5-06bb2764dc7d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  " Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e23446ac-19c4-400a-b0c2-4db5aabf4883",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["ad89e3b1-280a-49e7-8cb1-2236289caa4e"],
                },
              },
              {
                _uid: "ad89e3b1-280a-49e7-8cb1-2236289caa4e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4b6f145b-92ab-42d2-b2b9-e15b6a7d8080_e23446ac-19c4-400a-b0c2-4db5aabf4883",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "75d01791-ac6c-4c84-904f-68f3df0ddcdc",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 3.1.1 means that, if the merchant has paper storage of account data, the merchant has policies and procedures in place that govern merchant activities for Requirement 3. This helps to ensure personnel are aware of and following security policies and documented operational procedures for managing the secure storage of any paper records with account data.",
                  "If merchant does not store paper records with account data, mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // page 15 - Done
          {
            fields: [
              {
                _uid: "c0218266-0d5d-4875-ba35-9f4737b40444",
                component: "col",
                label: "",
                boldLabel: [
                  "3.3 Sensitive authentication data (SAD) is not stored after authorization.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bf50620b-2158-422b-a566-44b4fa168a8d",
                component: "col",
                label: "",
                boldLabel: "Applicability Notes for 3.3.1",
                subBoldLabel: [
                  "Part of this Applicability Note was intentionally blank for this SAQ as it does not apply to merchant assessments",
                  "Sensitive authentication data includes the data cited in Requirements 3.3.1.1 through 3.3.1.3.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b95618f5-8064-4294-a9c3-91c722a82998",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5ec314eb-4a33-4b66-ab00-c4277f258484",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "SAD is not retained after authorization, even if encrypted. All sensitive authentication data received is rendered unrecoverable upon completion of the authorization process.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a0d0e0b6-bac0-420c-b795-ec3349de31aa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Examine system configurations.",
                  "Observe the secure data deletion processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "884a2baa-c99e-4314-9197-34b8f13fb120",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["8c3072bf-c752-4177-aaa7-9a34540061e1"],
                },
              },
              {
                _uid: "8c3072bf-c752-4177-aaa7-9a34540061e1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "afc61f16-89ea-4657-b119-b54401f85372_884a2baa-c99e-4314-9197-34b8f13fb120",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a94f1b8e-26ce-4654-a92e-e86c6bd2d509",
                component: "col",
                label: "",
                boldLabel: "Applicability Notes for 3.3.1.1",
                subBoldLabel: [],
                subBoldLabelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "In the normal course of business, the following data elements from the track may need to be retained:",
                  ul: [
                    "Cardholder name",
                    "Primary account number (PAN).",
                    "Expiration date.",
                    "Service code.",
                    ,
                  ],
                  pr: "To minimize risk, store securely only these data elements as needed for business.",
                },
                hasLi: "yes",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "52aa69e8-81c9-4f6c-ba3e-bfe6919b8228",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c49879b8-d37c-47dc-9a62-a4cb5d058255",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The full contents of any track are not retained upon completion of the authorization process.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4fbe9b05-a4d8-4371-b53e-8c06b826cb39",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine data sources"],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c0c677a5-77d9-4980-a55c-a79378859195",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["8cc18584-503d-4d22-aef0-7b9f91f21c6f"],
                },
              },
              {
                _uid: "8cc18584-503d-4d22-aef0-7b9f91f21c6f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8cf25280-cc0f-4bed-af6e-9d6c3a60d959_c0c677a5-77d9-4980-a55c-a79378859195",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 16 - Done
          {
            fields: [
              {
                _uid: "a2452436-c68a-48bd-b754-b850dc350828",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 3.3.1.2",
                subBoldLabel: [
                  "The card verification code is the three- or four-digit number printed on the front or back of a payment card used to verify card-not-present transactions.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f1a444bc-db9c-42fe-b7d6-1275cab35b34",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "13d76fcd-09cd-4482-b52d-a6cb8746dcaa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The card verification code is not retained upon completion of the authorization process.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d39df6bb-412f-4612-a2e4-c2e4674c2618",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine data sources."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["6c9ab849-3896-4df7-b259-8df68143f010"],
                },
              },
              {
                _uid: "6c9ab849-3896-4df7-b259-8df68143f010",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "2caffed6-23f8-4ebc-86c1-a0b557d25656_bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5e013da2-eee7-4a6d-a80d-e7e41fb02ae8",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 3.3.1.2 means that if the merchant writes down the card verification code while a transaction is being conducted, the merchant either securely destroys the paper (for example, with a shredder) immediately after the transaction is complete, or obscures the code (for example, by “blacking it out” with a marker) before the paper is stored.",
                  "If the merchant never requests the three-digit or four-digit number printed on the front or back of a payment card (“card verification code”), mark the requirement as Not Applicable column and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "65e0780b-20b7-417a-92a9-415526d046f9",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 3.3.1.3",
                subBoldLabel: [
                  "PIN blocks are encrypted during the natural course of transaction processes, but even if an entity encrypts the PIN block again, it is still not allowed to be stored after the completion of the authorization process.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "73ef4345-f865-410b-be1e-a185e96a70c5",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "dbc40e5b-48c7-4813-9b8b-20d640f7d2c3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  " The personal identification number (PIN) and the PIN block are not retained upon completion of the authorization process.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2569b9f2-2449-43a3-92b3-2ace9804b786",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine data sources."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "feed0952-27ef-41ba-b2f1-9158b2b5a0fc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["4077c523-8029-42c6-a69b-419553e581d9"],
                },
              },
              {
                _uid: "4077c523-8029-42c6-a69b-419553e581d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4fd397ee-af51-4c22-a7bf-a58cfa1e2b74_feed0952-27ef-41ba-b2f1-9158b2b5a0fc",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 17 - Done
          {
            fields: [
              {
                _uid: "8459dc9e-c90d-4fad-9188-b8b330168f92",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 3.4.1",
                subBoldLabel: [
                  "This requirement does not supersede stricter requirements in place for displays of cardholder data—for example, legal or payment brand requirements for point-of-sale (POS) receipts.",
                  "This requirement relates to protection of PAN where it is displayed on screens, paper receipts, printouts, etc., and is not to be confused with Requirement 3.5.1 for protection of PAN when stored, processed, or transmitted.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ca70febf-b914-438b-b49c-6405b980e1b6",
                component: "col",
                label: "",
                simplifiedLabel: "3.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "edd02178-1cda-4c68-ac7e-630a93413ebe",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "PAN is masked when displayed (the BIN and last four digits are the maximum number of digits to be displayed), such that only personnel with a legitimate business need can see more than the BIN and last four digits of the PAN.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "72b2d2ab-9fb3-492a-9f61-e6fb36f5933f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Examine system configurations",
                  "Examine the documented list of roles that need access to more than the BIN and last four digits of the PAN (includes full PAN).",
                  "Examine displays of PAN (for example, on screen, on paper receipts).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e50e1d62-77b3-4a10-acc9-c757a70394dc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["4d97266f-8e91-40ce-b5a4-f01b4bff807b"],
                },
              },
              {
                _uid: "4d97266f-8e91-40ce-b5a4-f01b4bff807b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3b90c256-ceab-43b2-82da-1612e759ff10_e50e1d62-77b3-4a10-acc9-c757a70394dc",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 18 - Done
          {
            fields: [
              {
                _uid: "f09e53a9-5346-43da-9520-004e41785dbd",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "Implement Strong Access Control Measures",
                  "Requirement 7: Restrict Access to System Components and Cardholder Data by Business Need to Know",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "83363e4c-9a6d-46ba-aefe-4997d607bd05",
                component: "col",
                label: "",
                boldLabel: [
                  "7.2 Access to system components and data is appropriately defined and assigned.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c8c48877-bf28-41ee-9830-d0a1f8b5f876",
                component: "col",
                label: "",
                simplifiedLabel: "7.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "05d5ca4a-1b2c-459e-8290-1a06d76b68d8",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Access is assigned to users, including privileged users, based on:",
                  ul: [
                    "Job classification and function.",
                    "Least privileges necessary to perform job responsibilities.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b2d64597-2edc-4f88-825c-f87026fd947a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine user access settings, including for privileged users.",
                  "Interview responsible management personnel.",
                  "Interview personnel responsible for assigning access.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9ea42253-9833-4964-80c3-c04c0e36aef1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["09ec5a2e-720d-4754-91d6-b4d46ba55f45"],
                },
              },
              {
                _uid: "09ec5a2e-720d-4754-91d6-b4d46ba55f45",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "95f8b676-2d2a-43cd-9f75-c751c13033fb_9ea42253-9833-4964-80c3-c04c0e36aef1",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 19 - Done
          {
            fields: [
              {
                _uid: "472adf9e-c056-4550-b484-11cbf5dcef33",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "Requirement 9: Restrict Physical Access to Cardholder Data",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d24578eb-1f0a-4e30-b66e-a9a385c56ef8",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "9.4 Media with cardholder data is securely stored, accessed, distributed, and destroyed",
                ],
                subBoldLabel: [
                  "Note: For SAQ B, Requirements at 9.4 only apply to merchants with paper records (for example, receipts or printed reports) with account data, including primary account numbers (PANs).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "98b564fd-1b60-49f6-8c4b-1e5810cfc72d",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0d40388c-7a1d-460d-bf0c-e5535b71e804",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All media with cardholder data is physically secured.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8a08deaa-7c0f-4416-8976-83842481da8f",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine documentation."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "385b10b0-4424-4a71-9846-688a501716ad",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["f61941de-4197-4ee2-b58c-de6458c7157d"],
                },
              },
              {
                _uid: "f61941de-4197-4ee2-b58c-de6458c7157d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "6df077a2-679d-42bf-b0c7-cdb19c3e82de_385b10b0-4424-4a71-9846-688a501716ad",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "928497c5-4cc1-4e37-95c3-eb8a653e3fae",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "edeeeddf-5a41-413f-b365-9fb17fc6c6bb",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Offline media backups with cardholder data are stored in a secure location.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e905fbec-96b1-4ad8-8a07-4ed97f8468c0",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures.",
                  "Examine logs or other documentation.",
                  "Interview responsible personnel at the storge location(s).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6cfca733-fd59-465b-ba0f-86549b3220e7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["b8c2a9b1-be18-4af3-ba5e-fb92f2e7adce"],
                },
              },
              {
                _uid: "b8c2a9b1-be18-4af3-ba5e-fb92f2e7adce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4238b409-3e57-4e24-9d70-4603d9de8dce_6cfca733-fd59-465b-ba0f-86549b3220e7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "51686a5a-0a0c-4901-a209-8552e6f77b02",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "23cfda3c-c33f-4f14-b5e8-f177e2c035c3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All media with cardholder data is classified in accordance with the sensitivity of the data.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "058db2c6-e404-481b-911a-547c0ad0762d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures.",
                  "Examine media logs or other documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8fa12b9e-7ace-4423-b4a3-c6e2f3cd99cd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["54f668c6-c655-4cfb-a31a-ea8788a9d04a"],
                },
              },
              {
                _uid: "54f668c6-c655-4cfb-a31a-ea8788a9d04a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "b3d230ef-e40c-45b4-a402-eca43035d4bf_8fa12b9e-7ace-4423-b4a3-c6e2f3cd99cd",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f03fa038-6ad8-420f-9f6e-0a22fc6d84c9",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d8027f35-f39d-45c7-8d08-56eccd95027b",
                component: "col",
                label: [],
                simplifiedLabel: [""],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Media with cardholder data sent outside the facility is secured as follows:",
                  ul: [
                    "Bullet intentionally left blank for this SAQ.",
                    "Media is sent by secured courier or other delivery method that can be accurately tracked.",
                    "Bullet intentionally left blank for this SAQ.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "357292a7-61e2-4d94-ab08-b661fd531e37",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures.",
                  "Interview personnel.",
                  "Examine records.",
                  "Examine offsite tracking logs for all media.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2acf72fe-8881-4f93-8b62-c5acfb53ffe2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["6bf90f6f-367b-4a11-a6cd-5052223783e4"],
                },
              },
              {
                _uid: "6bf90f6f-367b-4a11-a6cd-5052223783e4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "bbe10d50-6649-4a6e-986d-fcd573e56a95_2acf72fe-8881-4f93-8b62-c5acfb53ffe2",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "43f5276c-e6da-41b3-951b-adb35f76286b",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 9.4.4",
                subBoldLabel: [
                  "Individuals approving media movements should have the appropriate level of management authority to grant this approval. However, it is not specifically required that such individuals hav “manager” as part of their title.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8100502c-d2bd-457e-9939-caefcfb2fe60",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "61083771-38c6-447b-9a7e-def34f6840d4",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Management approves all media with cardholder data that is moved outside the facility (including when media is distributed to individuals).",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8b4eebba-016a-418a-a528-00372d19acf9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures.",
                  "Examine offsite media tracking logs.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dfe6ec31-a754-4c39-9cbc-cf030693d86d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["290c2f42-52d1-41c8-96e2-7b816fe3e350"],
                },
              },
              {
                _uid: "290c2f42-52d1-41c8-96e2-7b816fe3e350",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "5f9911be-eedf-4787-85b8-b8043288458a_dfe6ec31-a754-4c39-9cbc-cf030693d86d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 20
          {
            fields: [
              {
                _uid: "c4ba03a2-4577-4cd6-962d-2d6be618e49d",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 9.4.6",
                subBoldLabel: [
                  "These requirements for media destruction when that media is no longer needed for business or legal reasons are separate and distinct from PCI DSS Requirement 3.2.1, which is for securely deleting cardholder data when no longer needed per the entity’s cardholder data retention policies.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f72385cc-d0f8-4f0e-a61a-4ac56cd56b3e",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4cdeb9c6-1c29-4517-a174-d365d48d781d",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Hard-copy materials with cardholder data are destroyed when no longer needed for business or legal reasons, as follows:",
                  ul: [
                    "Materials are cross-cut shredded, incinerated, or pulped so that cardholder data cannot be reconstructed.",
                    "Materials are stored in secure storage containers prior to destruction.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "352eabb1-a91d-4024-b351-793cb29a51df",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the periodic media destruction policy.",
                  "Observe processes.",
                  "Interview personnel.",
                  "Observe storage containers.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "da2ce266-0409-4361-97c7-0231f729d75e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["9f88b0eb-fe21-4c3d-b939-4fd48528d05c"],
                },
              },
              {
                _uid: "9f88b0eb-fe21-4c3d-b939-4fd48528d05c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "e87735d9-a8f8-460d-ad92-b8c8324be891_da2ce266-0409-4361-97c7-0231f729d75e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 21
          {
            fields: [
              {
                _uid: "ee842440-906b-4043-b13b-5b8c05fbf6ac",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements at 9.4 means that the merchant securely stores any paper media with account data, for example by storing the paper in a locked drawer, cabinet, or safe, and that the merchant destroys such paper when no longer needed for business purposes. This includes a written document or policy for employees, so they know how to secure paper with account data and how to destroy the paper when no longer needed.",
                  "If the merchant never stores any paper with account data, mark the requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                boldLabel: "",
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ded9d7e1-8f5f-45d1-b6d2-a53b44f96bc0",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel:
                  "9.5 Point-of-interaction (POI) devices are protected from tampering and unauthorized substitution.",
                subBoldLabel: [""],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a25b2405-84f4-46e7-ad4c-f411fc2f1327",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 9.5.1",
                subBoldLabel: [
                  "These requirements apply to deployed POI devices used in card-present transactions (that is, a payment card form factor such as a card that is swiped, tapped, or dipped). This requirement is not intended to apply to manual PAN key-entry components such as computer keyboards.",
                  "This requirement is recommended, but not required, for manual PAN key-entry components such as computer keyboards.",
                  "This requirement does not apply to commercial off-the-shelf (COTS) devices (for example, smartphones or tablets), which are mobile merchant-owned devices designed for mass-market distribution.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fd97586d-f55d-4451-8397-98753a108eb9",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5216a1e9-2e2b-4e48-a333-b4d80444baa5",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "POI devices that capture payment card data via direct physical interaction with the payment card form factor are protected from tampering and unauthorized substitution, including the following:",
                  ul: [
                    "Maintaining a list of POI devices.",
                    "Periodically inspecting POI devices to look for tampering or unauthorized substitution.",
                    "Training personnel to be aware of suspicious behavior and to report tampering or unauthorized substitution of devices.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "750dbc1e-8e1f-4042-81f5-5767a2e5d70d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d34243f0-167c-44a2-bbb0-ff94ddfcc23b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["cadc4dab-22fe-4dec-b187-a104fea468a8"],
                },
              },
              {
                _uid: "cadc4dab-22fe-4dec-b187-a104fea468a8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7c2fed15-0daf-4b71-ae80-2620211d56f9_d34243f0-167c-44a2-bbb0-ff94ddfcc23b",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1d40276d-2763-487d-9c7c-1f70fb9e664b",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8a6e4aaa-97da-4efb-a97a-c22c6ff895c4",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "An up-to-date list of POI devices is maintained, including:",
                  ul: [
                    "Make and model of the device. ",
                    "Location of device. ",
                    "Device serial number or other methods of unique identification.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "62403ea3-5921-477b-8dc3-170f3f73f964",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the list of POI devices",
                  "Observe POI devices and device locations.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e3994cdd-8ae0-484d-9268-263d3a3fa7ef",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["9ade9dc4-39af-4124-a0d1-5972f59b3d3b"],
                },
              },
              {
                _uid: "9ade9dc4-39af-4124-a0d1-5972f59b3d3b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "918008c0-f79a-4a6c-8ae1-336ab6d5cce0_e3994cdd-8ae0-484d-9268-263d3a3fa7ef",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4f941a6f-93de-4d9b-9e7f-d13d32bc35da",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1f21a6bd-5e4b-49c8-b115-09a46e40e32a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "POI device surfaces are periodically inspected to detect tampering and unauthorized substitution.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7117021b-a2fd-4b13-906b-1cf49c8661ff",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures.",
                  "Interview responsible personnel.",
                  "Observe inspection processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6020abb3-c51c-4d09-8968-415b5681eb59",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["d85edc31-a5ae-4825-9792-0b599679cdd4"],
                },
              },
              {
                _uid: "d85edc31-a5ae-4825-9792-0b599679cdd4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "03c29b2b-6928-4c5d-a277-a64e5b404b77_6020abb3-c51c-4d09-8968-415b5681eb59",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 22 - Done
          {
            fields: [
              {
                _uid: "c60d713a-7de9-44eb-b0df-c7a273ed51f9",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b4559368-1f82-4b6a-b62e-d45d4b69ed5d",
                component: "col",
                label: [],
                simplifiedLabel: [""],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Training is provided for personnel in POI environments to be aware of attempted tampering or replacement of POI devices, and includes:",
                  ul: [
                    "Verifying the identity of any third-party persons claiming to be repair or maintenance personnel, before granting them access to modify or troubleshoot devices.",
                    "Procedures to ensure devices are not installed, replaced, or returned without verification.",
                    "Being aware of suspicious behavior around devices.",
                    "Reporting suspicious behavior and indications of device tampering or substitution to appropriate personnel.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7fda4cee-1c4f-4b94-9b17-c6cb689fc7ef",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Review training materials for personnel in POI environments",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5409ac7e-93db-45b1-aa80-5c98807e051e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["84351ca3-6022-4eb0-b17e-293d112bcae4"],
                },
              },
              {
                _uid: "84351ca3-6022-4eb0-b17e-293d112bcae4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "83deff2e-daed-4e3d-b023-8ea57e90112a_5409ac7e-93db-45b1-aa80-5c98807e051e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1fd5e8ae-3f24-4b62-80a6-ec240e100332",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements at 9.5 means that the merchant has policies and procedures in place for Requirements 9.5.1, 9.5.1.1, 9.5.1.2, and 9.5.1.3, and that it maintains a current list of devices, conducts periodic device inspections, and trains employees about what to look for to detect tampered or substituted devices",
                ],
                boldLabel: "",
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // page 23 - Done
          {
            fields: [
              {
                _uid: "34587d9e-9850-4533-af61-2c56e3a2306d",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "Maintain an Information Security Policy ",
                  "Requirement 12: Support Information Security with Organizational Policies and Programs",
                ],
                subBoldLabel: [
                  "Note: Requirement 12 specifies that merchants have information security policies for their personnel, but these policies can be as simple or complex as needed for the size and complexity of the merchant’s operations. The policy document must be provided to all personnel, so they are aware of their responsibilities for protecting payment terminals, any paper documents with account data, etc. If a merchant has no employees, then it is expected that the merchant understands and acknowledges their responsibility for security within their store(s).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "427b202c-4934-470b-96a4-f022b673581e",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "12.1 A comprehensive information security policy that governs and provides direction for protection of the entity’s information assets is known and current.",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "094423e0-8643-4cfa-95c6-ffbd0239f84a",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "594eca54-cccb-4d8c-b396-86d8621e78dc",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "An overall information security policy is:",
                  ul: [
                    "Established",
                    "Published",
                    "Maintained",
                    "Disseminated to all relevant personnel, as well as to relevant vendors and business partners.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "89d4eac8-3125-49d9-910f-859e8711a670",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the information security policy.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8eb94fd6-20ce-4519-ab04-213cc3efce32",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["f100de8f-2a50-46d4-948e-6170d8f182ee"],
                },
              },
              {
                _uid: "f100de8f-2a50-46d4-948e-6170d8f182ee",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4ecd460d-de33-4a89-b947-4987b0f16721_8eb94fd6-20ce-4519-ab04-213cc3efce32",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e09da3d9-7ee6-47cd-9a7f-5bd3b0d0b271",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "aed71698-462b-46ee-9922-00fcc7f49344",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "The information security policy is:",
                  ul: [
                    "Reviewed at least once every 12 months.",
                    "Updated as needed to reflect changes to business objectives or risks to the environment.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f065c7c2-87cd-46c8-820d-c0faea76c53a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the information security policy.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bfb04652-66eb-4057-b1fc-0fa508922135",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["1c13fc24-7285-400d-8df3-9885d78208e2"],
                },
              },
              {
                _uid: "1c13fc24-7285-400d-8df3-9885d78208e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "0e1614c0-1148-4c21-9e09-5687f560ada0_bfb04652-66eb-4057-b1fc-0fa508922135",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "081f5513-324b-4cea-9d56-a54cfd84bd37",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements 12.1.1 and 12.1.2 means that the merchant has a security policy that is reasonable for the size and complexity of the merchant’s operations, and that the policy is reviewed at least once every 12 months and updated if needed.",
                ],
                boldLabel: [],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4756cf7b-db9b-465e-a599-462cb53ef69c",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c97a4d3e-5b67-4223-8b96-132837100a79",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The security policy clearly defines information security roles and responsibilities for all personnel, and all personnel are aware of and acknowledge their information security responsibilities",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b2a18bd8-943b-4b8a-b52c-0de534152812",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the information security policy.",
                  "Interview responsible personnel.",
                  "Examine documented evidence.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7ed9c184-b79b-4371-a9bc-dbfa0122f30c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["4d0f6ec8-76ce-4c01-a6cd-d6469955bb21"],
                },
              },
              {
                _uid: "4d0f6ec8-76ce-4c01-a6cd-d6469955bb21",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "1634dd76-ec0d-4554-a052-e7587469211d_7ed9c184-b79b-4371-a9bc-dbfa0122f30c",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 24 - Done
          {
            fields: [
              {
                _uid: "12d2f318-eae1-49d4-b81f-906f1159898d",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Selection of any of the In Place responses for Requirement 12.1.3 means that the merchant’s security policy defines basic security responsibilities for all personnel, consistent with the size and complexity of the merchant’s operations. For example, security responsibilities could be defined according to basic responsibilities by employee levels, such as the responsibilities expected of a manager/owner and those expected of clerks.",
                ],
                boldLabel: "",
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ba7d8545-0b4a-4200-b7f7-dc0e458e8099",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "12.6 Security awareness education is an ongoing activity.",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b09689c0-b809-432a-94bc-b3f4438880ca",
                component: "col",
                label: "",
                simplifiedLabel: "12.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "022ef89f-2006-4485-b9d8-bb8ce9a06b22",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A formal security awareness program is implemented to make all personnel aware of the entity’s information security policy and procedures, and their role in protecting the cardholder data.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "39a30601-ba0a-4f66-9dee-6dff6209ec90",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine the security awareness program."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b70a1c21-98dd-4bba-8242-f5d35ca986a2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["5425b47e-91ab-4f92-8fb6-90befe91161e"],
                },
              },
              {
                _uid: "5425b47e-91ab-4f92-8fb6-90befe91161e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "cf60f244-9444-4a6e-90a3-ef12b6d408fd_b70a1c21-98dd-4bba-8242-f5d35ca986a2",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "30ded413-9250-4902-bafd-ff61a344e96f",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 12.6.1 means that the merchant has a security awareness program in place, consistent with the size and complexity of the merchant’s operations. For example, a simple awareness program could be a flyer posted in the back office, or a periodic e-mail sent to all employees. Examples of awareness program messaging include descriptions of security tips all employees should follow, such as how to lock doors and storage containers, how to determine whether a payment terminal has been tampered with, and processes to confirm the identity and verify there is a legitimate business reason for any service workers when they arrive to service payment terminals.",
                ],
                boldLabel: [],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "723da3f6-e4a4-4111-92db-2131de6dbf7d",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "12.8 Risk to information assets associated with third-party service provider (TPSP) relationships is managed.",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "77cc007f-e5ab-46f2-99e7-50b6004fb4a7",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: ["Applicability Notes for 12.8.1"],
                subBoldLabel: [
                  "The use of a PCI DSS compliant TPSP does not make an entity PCI DSS compliant, nor does it remove the entity’s responsibility for its own PCI DSS compliance",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a0744a35-a83e-4a01-b575-f9a65cb4b29b",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c72a8d59-b301-4999-ac52-dd894fe8c8b8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A list of all third-party service providers (TPSPs) with which account data is shared or that could affect the security of account data is maintained, including a description for each of the services provided.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dcefef06-9b0c-42a7-aded-a61c513d1131",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine list of TPSPs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "409155bb-1597-43c2-ba36-f3d6b94139fa",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["4e688a9d-e9d5-4ff3-9924-04ba08ce849c"],
                },
              },
              {
                _uid: "4e688a9d-e9d5-4ff3-9924-04ba08ce849c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "52400ba0-8343-4f9f-8e62-ac36d5d8d97d_409155bb-1597-43c2-ba36-f3d6b94139fa",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 25 - Done
          {
            fields: [
              {
                _uid: "a8de3c3b-5115-4c8e-859a-3e51642f2659",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: ["Applicability Notes for 12.8.2"],
                subBoldLabel: [
                  "The exact wording of an acknowledgment will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgment does not have to include the exact wording provided in this requirement.",
                  "The exact wording of an acknowledgment will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgment does not have to include the exact wording provided in this requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dd5ae7e7-7c50-4998-8ebc-a453c4619c35",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2d52e840-2738-4fad-ad24-67c5a2a527d1",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Written agreements with TPSPs are maintained as follows:",
                  ul: [
                    "Written agreements are maintained with all TPSPs with which account data is shared or that could affect the security of the CDE.",
                    "Written agreements include acknowledgments from TPSPs that they are responsible for the security of account data the TPSPs possess or otherwise store, process, or transmit on behalf of the entity, or to the extent that they could impact the security of the entity’s CDE.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "50b978c0-f5ad-4ae3-93d5-dd04da18715d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine written agreements with TPSPs",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9e55ca08-ec3e-4b24-8446-2da83da984fd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["3a31b3ae-3d19-447f-bb3b-8bf0e1232849"],
                },
              },
              {
                _uid: "3a31b3ae-3d19-447f-bb3b-8bf0e1232849",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "36b959b3-4ead-441c-a69f-0e39835d9e2e_9e55ca08-ec3e-4b24-8446-2da83da984fd",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c93878a-3d00-4b06-989b-53a88c916f48",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b4634c7a-a9fd-4da4-8ca7-1ae35ca427f1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An established process is implemented for engaging TPSPs, including proper due diligence prior to engagement.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a4dcb832-314f-4e00-86d8-8e716c6e03f9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine evidence.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d5840692-355c-4878-87fe-86c225868493",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["2406b8a1-f0ba-417d-90cb-705d0ec2522b"],
                },
              },
              {
                _uid: "2406b8a1-f0ba-417d-90cb-705d0ec2522b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "6455bb69-a333-41a4-b890-681f8711c807_d5840692-355c-4878-87fe-86c225868493",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "05739530-3218-4698-9b09-083310c9f148",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: ["Applicability Notes for 12.8.4"],
                subBoldLabel: [
                  "Where an entity has an agreement with a TPSP for meeting PCI DSS requirements on behalf of the entity (for example, via a firewall service), the entity must work with the TPSP to make sure the applicable PCI DSS requirements are met. If the TPSP does not meet those applicable PCI DSS requirements, then those requirements are also “not in place” for the entity",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a8e27430-ef2b-42ba-98e8-45667d966f4c",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c2e8fa16-5a32-4a11-ac1b-37ebd4d63fcd",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A program is implemented to monitor TPSPs’ PCI DSS compliance status at least once every 12 months.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b90a4418-ec34-4c6d-afbf-9afac1f15afd",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine documentation.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "74b33313-eff5-4e21-ac48-86fe53e970fb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["2e87d9f8-f38f-4a72-a632-b84addf9a3bb"],
                },
              },
              {
                _uid: "2e87d9f8-f38f-4a72-a632-b84addf9a3bb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "0f63969c-9423-4603-9721-cb3d9effc34e_74b33313-eff5-4e21-ac48-86fe53e970fb",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // page 26 - Done
          {
            fields: [
              {
                _uid: "6ff1f2b1-f41b-4b94-84d4-b38a1212ab29",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ece6db60-3175-48f8-9d0d-b0daae01145b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Information is maintained about which PCI DSS requirements are managed by each TPSP, which are managed by the entity, and any that are shared between the TPSP and the entity.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0b12fbdf-8a19-438d-a17e-ef072bfa203c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine documentation.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e8b661c5-9d09-4610-be60-deecbac37a7d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["4e7fb2d5-9b6e-4c85-b2ae-13db2c861c84"],
                },
              },
              {
                _uid: "4e7fb2d5-9b6e-4c85-b2ae-13db2c861c84",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "574c486b-cc26-4538-9962-f96b1b377271_e8b661c5-9d09-4610-be60-deecbac37a7d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b09d2203-9130-41ee-bab2-e0b5b754a893",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for requirements at 12.8.1 through 12.8.5 means that the merchant has a list of, and agreements with, service providers it shares account data with or that could impact the security of the merchant’s cardholder data environment. For example, such agreements would be applicable if a merchant uses a document-retention company to store paper documents that include account data or if a merchant’s vendor accesses merchant systems remotely to perform maintenance.",
                ],
                boldLabel: [],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a5b1fd4-9799-4926-8a01-940abda29061",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "12.10 Suspected and confirmed security incidents that could impact the CDE are responded to immediately",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "09b84f6f-43a2-4526-8ca2-1f23b173fad9",
                component: "col",
                label: "",
                simplifiedLabel: "12.10.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "83e05646-6849-40e5-a6be-c2d55266a126",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An incident response plan exists and is ready to be activated in the event of a suspected or confirmed security incident.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fb62ecaa-bc7e-4c5e-b857-80ab14a8072d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the incident response plan",
                  "Interview personnel.",
                  "Examine documentation from previously reported incidents.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0c320f6a-137e-44aa-854c-8716d209dff8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["2979a205-ce0a-48e5-99f3-1e1ac7872036"],
                },
              },
              {
                _uid: "2979a205-ce0a-48e5-99f3-1e1ac7872036",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "b9de257e-eeb1-4a0e-964f-9ba7ffabe841_0c320f6a-137e-44aa-854c-8716d209dff8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3a4fe25b-83e1-448d-903a-d217dd9056e6",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 12.10.1 means that the merchant has documented an incident response and escalation plan to be used for emergencies, consistent with the size and complexity of the merchant’s operations. For example, such a plan could be a simple document posted in the back office that lists who to call in the event of various situations with an annual review to confirm it is still accurate, but could extend all the way to a full incident response plan including backup “hotsite” facilities and thorough annual testing. This plan should be readily available to all personnel as a resource in an emergency.",
                ],
                boldLabel: [],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 27 NA
  // Page 28 - Done
  {
    _uid: "dab5ee3f-880d-4aa2-9f08-457d4f3a9731",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Appendix B: Compensating Controls Worksheet",
    fields: [
      {
        _uid: "9daab1fd-0b33-4945-b3d1-0eee9eb91030",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "This Appendix must be completed to define compensating controls for any requirement where In Place with CCW was selected.",
          "Note: Only entities that have a legitimate and documented technological or business constraint can consider the use of compensating controls to achieve compliance",
          "Refer to Appendices B and C in PCI DSS for information about compensating controls and guidance on how to complete this worksheet.",
        ],
        simplifiedBoldHeaderBelowSimplifiedCaption:
          "Requirement Number and Definition:",
        headers: ["", "Information Required", "Explanation"],
        fields: [
          {
            fields: [
              {
                _uid: "de0a670f-733d-499c-aaf3-1809dd7d9ee1",
                component: "col",
                label: [""],
                simplifiedLabel: ["1. Constraints"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "945fb1ac-20f5-4fa4-aa84-fa2220e98ffd",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Document the legitimate technical or business constraints precluding compliance with the original requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "fb2239c6-fa8b-479f-879b-452a4b5dce51",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c9d2277-a966-49d2-bfe8-7a4da7021bbc",
                component: "col",
                label: [""],
                simplifiedLabel: ["2. Definition of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8664ee54-d714-4ff7-b14f-8fd1405e9fb6",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define the compensating controls: explain how they address the objectives of the original control and the increased risk, if any. ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "7e1b04e8-df1d-4da2-8823-22aa1c320979",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "027ef055-9911-49d2-800a-00e0843df4a9",
                component: "col",
                label: [""],
                simplifiedLabel: ["3. Objective"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "dae5ee30-a548-40c8-aeef-e8d1395482f7",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define the objective of the original control.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ec8d9a96-5d17-44f2-83a5-e84ee8db369b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "228a69c9-4e4d-4f91-a8bd-0a5f004bf5ca",
                component: "col",
                label: [""],
                simplifiedLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "cd8d53c5-90c6-4ef3-946d-1ff2804a306d",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify the objective met by the compensating control.",
                  "Note: This can be, but is not required to be, the stated Customized Approach Objective listed for this requirement in PCI DSS.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "23386351-dfc0-4716-9e95-a109b2b9584d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "225",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d24ea8c5-8e3a-4169-9382-694d15de0095",
                component: "col",
                label: [""],
                simplifiedLabel: ["4. Identified Risk"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c65b215d-9473-4a3b-83fa-4f38e280a86c",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify any additional risk posed by the lack of the original control.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ac43edc2-cc76-4dab-a281-c0f4920e21d6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "95e41bd3-f17f-4913-8586-8ec91b525370",
                component: "col",
                label: [""],
                simplifiedLabel: ["5. Validation of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3385059a-2a84-4c17-8fa6-71415e4fd63f",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define how the compensating controls were validated and tested.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "275d5b08-cd5d-4fac-a9a7-dcedd56bbb45",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7579bd14-4a0e-45fe-96a2-580c3633c55e",
                component: "col",
                label: [""],
                simplifiedLabel: ["6. Maintenance"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ee1d386c-8f68-477a-8d0c-f21049dc48d1",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define process(es) and controls in place to maintain compensating controls.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f1b079bf-3df6-4939-891a-574c0fb4e583",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 29 - data inserted from radio na reason
  // Page 30 - NA
  // Page 31 - Done
  {
    _uid: "7e83a74e-5401-4afb-a7f8-102d9735de70",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Section 3: Validation and Attestation Details",
    fields: [
      {
        _uid: "c7270999-95f6-4d2e-a907-046872e56fd7",
        component: "table",
        label: "",
        simplifiedLabel: "Part 3. PCI DSS Validation",
        type: "table",
        caption: [],
        simplifiedBoldCaption: ["Part 3. PCI DSS Validation"],
        simplifiedCaption: [
          "This AOC is based on results noted in SAQ B (Section 2), dated (Self-assessment completion date YYYY-MM-DD).",
          "Based on the results documented in the SAQ B noted above, each signatory identified in any of Parts 3b−3d, as applicable, assert(s) the following compliance status for the merchant identified in Part 2 of this document.",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "7c7cc5b3-ff97-4bc7-9298-bbf8da13e3d6",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "c8b0e1e8-e107-4932-83ec-80b74330a20a",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Compliant: All sections of the PCI DSS SAQ are complete and all requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1fcd7a57-9df1-4900-8925-e81fdb116f05",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "Compliant",
                width: "20%",
              },
              {
                _uid: "c266fb46-9282-4ad8-bd7c-112265d8503f",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Non-Compliant: Not all sections of the PCI DSS SAQ are complete, or one or more requirements are marked as Not in Place, resulting in an overall NON-COMPLIANT rating, thereby (Merchant Company Name) has not demonstrated compliance with the PCI DSS requirements included in this SAQ.",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "A merchant submitting this form with a Non-Compliant status may be required to complete the Action Plan in Part 4 of this document. Confirm with the entity to which this AOC will be submitted before completing Part 4.",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                component: "checkbox",
                type: "checkbox",
                value: "yes",
                width: "20%",
                col: "12",
                resetFields: {
                  value: "",
                  _uids: [
                    "ba5792dd-b17b-449e-b2aa-1c619eed20df",
                    "5006af3f-fcdc-4c04-a002-aa05456e3984",
                    "e6b79503-be2a-403f-8636-ca57d9f9c3bc",
                    "1f559e4b-02e3-4443-a846-837debacbd65",
                    "602ec636-86d6-4944-932b-ddd81d0b0b75",
                    "92df6dc3-c01f-4170-809b-ff5ea0f189c4",
                    "715bb739-794d-46f4-9e82-a6b909a5b326",
                    "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                  ],
                },
              },
              {
                _uid: "2439ba3c-a98f-4259-8ecd-4d574697c1fe",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Compliant but with Legal exception: One or more assessed requirements in the PCI DSS SAQ are marked as Not in Place due to a legal restriction that prevents the requirement from being met and all other requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT BUT WITH LEGAL EXCEPTION rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ except those noted as Not in Place due to a legal restriction.",
                  "This option requires additional review from the entity to which this AOC will be submitted. If selected, complete the following:",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ba5792dd-b17b-449e-b2aa-1c619eed20df",
                component: "label",
                label: "",
                boldLabel: "Affected Requirement",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "11ab4969-da83-4b14-94ea-65ec33e4cfce_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                width: "50%",
              },
              {
                _uid: "5006af3f-fcdc-4c04-a002-aa05456e3984",
                component: "label",
                label: "",
                boldLabel:
                  "Details of how legal constraint prevents requirement being met",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "1c2ed136-0cb6-47b7-a403-ebd93ca5a285_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e6b79503-be2a-403f-8636-ca57d9f9c3bc",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "65971a55-9857-4899-a784-c01abb0fa044_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "1f559e4b-02e3-4443-a846-837debacbd65",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "d5867ec6-cbf8-454e-b7b3-017ad7913a2c_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "602ec636-86d6-4944-932b-ddd81d0b0b75",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "3848c469-8c36-4bcd-9b87-9a32434151b4_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "92df6dc3-c01f-4170-809b-ff5ea0f189c4",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "698387bc-14c6-4005-859c-9da0c41dd5b8_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "715bb739-794d-46f4-9e82-a6b909a5b326",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "7333d173-4c53-4d4a-89a4-f9f556d8bd36_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "60350b4b-15b4-4dc0-8a32-cfaf1afa3369_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 32 - Done
  {
    _uid: "f7c40153-fe36-4570-82dd-520eae2fba93",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "",
    fields: [
      {
        _uid: "3703ad33-f778-4bd8-b560-3398cb1513bb",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedBoldCaption: [
          "Part 3a. Merchant Acknowledgement",
          "Signatory(s) confirms:",
          "(Select all that apply)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "a63691e9-9567-4925-820d-8752abe6b612",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "ece6b93a-7d16-46da-8138-36ba3dc12eca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "PCI DSS Self-Assessment Questionnaire B, Version 4.0 was completed according to the instructions therein.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "38e7ba32-6b9e-4fc0-9d61-88fcd54ac6f5",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "e1d37b77-af21-404a-b097-f590e080d2fb",
                component: "col",
                label: "",
                simplifiedLabel:
                  "All information within the above-referenced SAQ and in this attestation fairly represents the results of the merchant’s assessment in all material respects.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f7a669dc-9758-48d4-82b9-e6722b0c7702",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "e6471716-6d26-4d89-b774-02143b7dc6ed",
                component: "col",
                label: "",
                simplifiedLabel:
                  "PCI DSS controls will be maintained at all times, as applicable to the merchant’s environment.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
      {
        _uid: "8f34029d-61d7-4367-aa3e-12f699040a34",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "Part 3b. Merchant Attestation",
        fields: [
          {
            fields: [
              {
                _uid: "3ef29462-9468-467a-8d33-668475e19187",
                component: "col",
                label: ["Signature of Merchant Executive Officer"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: "2",
                width: "60%",
              },
              {
                _uid: "b3e0e859-b26d-4b43-83fa-66ba717c8e2a",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "40%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b89c195b-c9b3-4ce2-b42e-8ada2e40452e",
                component: "col",
                label: [""],
                simplifiedLabel: ["Signature of Merchant Executive Officer"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "60%",
              },
              {
                _uid: "faed680a-fdae-491b-8709-482415861e49",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: 2,
                width: "40%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8ccbfc40-c74c-44c9-a7c9-c7a287f5541b",
                component: "col",
                label: [""],
                simplifiedLabel: ["Merchant Executive Officer Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "0089362f-b884-452d-9776-f263fdd3c854",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "14b71baa-67ec-487c-b3ad-550a01c8bae6",
                component: "col",
                label: [""],
                simplifiedLabel: ["Title"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5b418f20-5a39-47cd-8461-547185b91a05",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "35%",
                maxLength: "28",
              },
            ],
          },
        ],
      },
      {
        _uid: "6d65f61b-3db3-4dc2-bbf6-7aab1f08d25c",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption:
          "Part 3c. Qualified Security Assessor (QSA)Acknowledgement",
        fields: [
          {
            fields: [
              {
                _uid: "2bec4c53-6aef-41d8-9742-f87afea4130a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If a QSA was involved or assisted with this assessment, indicate the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "4",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "342c7f00-e529-4caa-b61b-eadc43297e95",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "bd573f0c-ea66-42be-8361-f5d544c925b6",
                component: "col",
                label: "",
                simplifiedLabel: "QSA performed testing procedures.",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f37d68dc-b295-4e6e-a257-d756f885ab53",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
                resetFields: {
                  value: "",
                  _uids: [
                    "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                    "35f6ff12-551f-411c-9f09-5262a8bc9882",
                    "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                    "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                    "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                    "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                    "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                    "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                    "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                    "af9fceed-d116-496d-abe6-e7364f54bc54",
                    "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                    "a16d9f36-c251-418f-ae30-09a81476075c",
                    "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                    "a3aa4592-abf0-446b-b9f4-2a254494befe",
                  ],
                },
              },
              {
                _uid: "ae4da7e1-24d5-4500-81ed-f48ec5fffe81",
                component: "col",
                label: "",
                simplifiedLabel:
                  "QSA provided other assistance. If selected, describe all role(s) performed:",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                component: "col",
                label: ["Signature of Lead QSA"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "c52e2f18-f82c-4430-83af-7a1f504ec37a_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "35f6ff12-551f-411c-9f09-5262a8bc9882",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "d03ca81e-8fc0-40bb-8779-221afdca5777_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                component: "col",
                label: [""],
                simplifiedLabel: ["Signature of Lead QSA"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "618009f8-60f2-4b71-ae30-ccc32ff61f9d_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "2e9289f6-2dd2-4a57-951e-8922ce0d230f_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                component: "col",
                label: [""],
                simplifiedLabel: ["Lead QSA Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "f78aa84f-c10e-4245-90b3-8a77fa04bf48_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "24ff9345-8cde-42ef-bd4e-a9c8f08bd200_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                component: "col",
                label: ["Signature of Duly Authorized Officer of QSA Company"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: 2,
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "d8b5ada2-e0bf-4c66-a7db-df659113c503_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: 2,
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "0081a7e9-4a50-4471-a122-1838914e2bc4_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Signature of Duly Authorized Officer of QSA Company",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 2,
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "0bf50a7d-1cae-437b-bc3b-d68d3ffbc2f0_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "af9fceed-d116-496d-abe6-e7364f54bc54",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: 2,
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "37e9409a-415a-4ab6-bcdc-e52e4f182d62_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                component: "col",
                label: [""],
                simplifiedLabel: ["Duly Authorized Officer Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                conditional: {
                  value: "yes",
                  field:
                    "0dd0847a-6c4d-4084-8b9d-589a11e48f33_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "a16d9f36-c251-418f-ae30-09a81476075c",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "25%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "635a5887-6188-4ce1-8cf1-077188312f19_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                component: "col",
                label: [""],
                simplifiedLabel: ["QSA Company:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
                conditional: {
                  value: "yes",
                  field:
                    "0c0ca787-57d6-42a0-ac0d-a21218e17384_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "a3aa4592-abf0-446b-b9f4-2a254494befe",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "30%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "a4c9e942-883a-4ddd-9657-a1b59cb7d73e_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "7dcf3b0b-4a10-4ab7-ad8c-0444a9e88f7b",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption:
          "Part 3d. PCI SSC Internal Security Assessor (ISA) Involvement",
        fields: [
          {
            fields: [
              {
                _uid: "57354855-b0ab-4f2d-8fcb-2609c472678e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If an ISA(s) was involved or assisted with this assessment, indicate the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "4",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "88542f99-4c83-4291-b18d-282e2b0632ee",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "ecf60fad-172b-48b7-af42-55583f2a3171",
                component: "col",
                label: "",
                simplifiedLabel: "ISA(s) performed testing procedures.",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e2c67566-11eb-4f56-b495-8ea89f703fa9",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
                resetFields: {
                  value: "",
                  _uids: ["6bbfebb8-6022-4ccb-aa16-4249a6d38e02"],
                },
              },
              {
                _uid: "2462213e-afc6-4e28-9c7c-4d5cf4c2c54a",
                component: "col",
                label: "",
                simplifiedLabel:
                  "ISA(s) provided other assistance. If selected, describe all role(s) performed:",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6bbfebb8-6022-4ccb-aa16-4249a6d38e02",
                component: "col",
                label: "",
                simplifiedLabel: "",
                placeholder: "Describe all role(s) performed",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                colSpan: 4,
                conditional: {
                  value: "yes",
                  field:
                    "7a710f1f-871f-4e23-b074-c2c0389ab984_e2c67566-11eb-4f56-b495-8ea89f703fa9",
                },
                width: "100%",
                maxLength: "320",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 33
  {
    _uid: "6703f7b8-d620-4566-ba6b-57e9c2d3af2b",
    layout: "form",
    component: "page",
    label: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "ad8680c0-ba56-4145-83bc-f20850f511f5",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                boldLabel: "Part 4. Action Plan for Non-Compliant Requirements",
                subBoldLabel: [
                  "Only complete Part 4 upon request of the entity to which this AOC will be submitted, and only if the Assessment has a Non-Compliant status noted in Section 3.",
                  "If asked to complete this section, select the appropriate response for “Compliant to PCI DSS Requirements” for each requirement below. For any “No” responses, include the date the merchant expects to be compliant with the requirement and a brief description of the actions being taken to meet the requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
            ],
          },
        ],
      },
      {
        _uid: "afb88315-dfc5-483e-b1d6-d727d7d569d6",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: [
          "PCI DSS Requirement*",
          "Description of Requirement",
          "Compliant to PCI DSS Requirements",
          "Remediation Date and Actions (If “NO” selected for any Requirement)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [""],
                simplifiedLabel: ["3"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8fd97f10-d533-4004-a6ed-e4cad018e190",
                component: "col",
                label: [""],
                simplifiedLabel: ["Protect stored account data"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3de2fb2a-abeb-4d2a-8480-638084717840",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["0d523bb5-d058-402f-8abb-7f05a1d77a8e"],
                },
              },
              {
                _uid: "0d523bb5-d058-402f-8abb-7f05a1d77a8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                conditional: {
                  value: "no",
                  field:
                    "d9c63712-899e-4466-8e12-1fd267bff257_3de2fb2a-abeb-4d2a-8480-638084717840",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a799130-aef0-401e-8f88-a243cb56b628",
                component: "col",
                label: [""],
                simplifiedLabel: ["7"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7af99412-1790-49b0-80f3-8452bc7086d2",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Restrict access to system components and cardholder data by business need to know",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c03217d3-7e28-4aaa-96de-5d246e84b703",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["7a0eca31-d1df-4d1c-92c7-9841be86d4bc"],
                },
              },
              {
                _uid: "7a0eca31-d1df-4d1c-92c7-9841be86d4bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "35d5ab45-31a3-4480-98f8-f3965ac2e831_c03217d3-7e28-4aaa-96de-5d246e84b703",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7d909157-3e85-402c-afc9-9687534cc37e",
                component: "col",
                label: [""],
                simplifiedLabel: ["9"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5aab4319-f9df-4a5a-b2ea-5d6c94adc638",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Restrict physical access to cardholder data",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["d218a370-bedf-4c06-ab0c-c3593d20ef19"],
                },
              },
              {
                _uid: "d218a370-bedf-4c06-ab0c-c3593d20ef19",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "df56def8-f3ee-457a-bf33-b2746962fd81_e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ed73014a-a854-4649-876e-0cf100b71974",
                component: "col",
                label: [""],
                simplifiedLabel: ["12"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5743ddfe-e0f4-4be0-b769-c499ea77d1c0",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Support information security with organizational policies and programs",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d91076ae-a1e6-4aca-8f77-f4b61721f355",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["1206feba-b01d-4284-871f-6b56114cc49b"],
                },
              },
              {
                _uid: "1206feba-b01d-4284-871f-6b56114cc49b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "b546da83-5f01-46b5-b25d-6579d5374689_d91076ae-a1e6-4aca-8f77-f4b61721f355",
                },
              },
            ],
          },
          /* {
            fields: [
              {
                _uid: "6d4ad0b7-0ba7-4c8b-80c6-a2a28e610800",
                component: "col",
                label: [""],
                simplifiedLabel: ["9"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "eabb273e-9804-4ea8-860a-7cef8b416ed6",
                component: "col",
                label: [""],
                simplifiedLabel: ["Restrict physical access to cardholder data"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "1120c4c9-880b-4787-a77c-d854d94c1501",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["48fdc1a5-b71e-44dc-a3a9-8425ea492c6a"],
                },
              },
              {
                _uid: "48fdc1a5-b71e-44dc-a3a9-8425ea492c6a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field: "662efa04-11e0-4262-ad45-977624cda7fe_1120c4c9-880b-4787-a77c-d854d94c1501",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dea416ea-1090-4822-a15b-0245c4d48062",
                component: "col",
                label: [""],
                simplifiedLabel: ["11"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6c7c3e23-4fda-4ce8-8842-e2b23e879a26",
                component: "col",
                label: [""],
                simplifiedLabel: ["Test security systems and networks regularly"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8542b132-8ccb-4a81-9b79-f820bc26ff56",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["a165d774-a674-435b-98c8-833d28279384"],
                },
              },
              {
                _uid: "a165d774-a674-435b-98c8-833d28279384",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field: "918afec2-8143-403d-aba9-be4cbcadb252_8542b132-8ccb-4a81-9b79-f820bc26ff56",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "93106548-c28e-4007-9f0f-6567043bbda6",
                component: "col",
                label: [""],
                simplifiedLabel: ["12"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66c5df27-b83a-404e-9d01-a8f2beb5fda2",
                component: "col",
                label: [""],
                simplifiedLabel: ["Support information security with organizational policies and programs"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["50377fbd-8c89-4199-8ff4-30ad491f04a9"],
                },
              },
              {
                _uid: "50377fbd-8c89-4199-8ff4-30ad491f04a9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field: "b7e8f327-cc1f-434d-b945-058332bc69f3_b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                },
              },
            ],
          }, */
        ],
      },
    ],
  },
];
